import { useState, useCallback } from 'react';
import API from 'api/api';

export default function useDisableTruck() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const disableTruck = useCallback(async (truckId) => {
    setLoading(true);
    setError(null);

    try {
      await API.put(`/trucks/${truckId}/disable`);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err);
      setLoading(false);
      return false;
    }
  }, []);

  return { disableTruck, loading, error };
}
